export function request(email) {
    return {
        type: 'USER_FORGOT_REQUEST',
        email
    };
}

export function error(errors) {
    return {
        type: 'USER_FORGOT_ERROR',
        errors
    };
}

export function finish() {
    return {
        type: 'USER_FORGOT_FINISH'
    };
}

export function clear() {
    return {
        type: 'USER_FORGOT_CLEAR'
    };
}
